import Vue from "vue";
import { i18n } from "@/i18n";
import moment from "moment";
import Web3 from "web3";
import { ABI } from "./abi/index";
import {
  getABIs,
  addABI,
  getMethodIDs,
  decodeMethod,
  decodeLogs,
  removeABI,
  keepNonDecodedLogs,
  discardNonDecodedLogs,
} from "./abiDecoderUtils";
import { contractAddressArr, amountAccuracy, transactionObj } from "./constant";
const web3 = new Web3();
export function timestampFormat(time) {
  // return moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
  return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
}

export const floatObj = (function () {
  /*
   * 判断obj是否为一个整数
   */
  function isInteger(obj) {
    return Math.floor(obj) === obj;
  }

  /*
   * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
   * @param floatNum {number} 小数
   * @return {object}
   *   {times:100, num: 314}
   */
  function toInteger(floatNum) {
    var ret = { times: 1, num: 0 };
    if (isInteger(floatNum)) {
      ret.num = floatNum;
      return ret;
    }
    var strfi = floatNum + "";
    var dotPos = strfi.indexOf(".");
    var len = strfi.substr(dotPos + 1).length;
    var times = Math.pow(10, len);
    var intNum = parseInt(floatNum * times + 0.5, 10);
    ret.times = times;
    ret.num = intNum;
    return ret;
  }

  /*
   * 核心方法，实现加减乘除数据运算，确保不丢失精度
   * 思路：把小数放大为整数（乘），进行算术数据运算，再缩小为小数（除）
   *
   * @param a {number} 数据运算数1
   * @param b {number} 数据运算数2
   * @param op {string} 数据运算类型，有加减乘除（add/subtract/multiply/divide）
   *
   */
  function operation(a, b, op) {
    var o1 = toInteger(a);
    var o2 = toInteger(b);
    var n1 = o1.num;
    var n2 = o2.num;
    var t1 = o1.times;
    var t2 = o2.times;
    var max = t1 > t2 ? t1 : t2;
    var result = null;
    switch (op) {
      case "add":
        if (t1 === t2) {
          // 两个小数位数相同
          result = n1 + n2;
        } else if (t1 > t2) {
          // o1 小数位 大于 o2
          result = n1 + n2 * (t1 / t2);
        } else {
          // o1 小数位 小于 o2
          result = n1 * (t2 / t1) + n2;
        }
        return result / max;
      case "subtract":
        if (t1 === t2) {
          result = n1 - n2;
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2);
        } else {
          result = n1 * (t2 / t1) - n2;
        }
        return result / max;
      case "multiply":
        result = (n1 * n2) / (t1 * t2);
        return result;
      case "divide":
        result = (n1 / n2) * (t2 / t1);
        return result;
    }
  }
  // 加减乘除的四个接口
  function add(a, b) {
    return operation(a, b, "add");
  }
  function subtract(a, b) {
    return operation(a, b, "subtract");
  }

  function multiply(a, b) {
    return operation(a, b, "multiply");
  }

  function divide(a, b) {
    return operation(a, b, "divide");
  }
  // exports
  return {
    add: add,
    subtract: subtract,
    multiply: multiply,
    divide: divide,
  };
})();

export function getUnit(item) {
  if (!item) {
    return "DTT";
  }
  if (typeof item == "string") {
    if (["0x", "0x0"].includes(item)) {
      return "DTT";
    }
    let val = item.toLowerCase();
    let obj = {};
    contractAddressArr.forEach((item) => {
      obj[item.address] = item.unit;
    });
    return obj[val] ? obj[val] : null;
  }
  if (typeof item == "object") {
    if (["0x", "0x0"].includes(item.input)) {
      return "DTT";
    }
    if (item.input && item.input.length > 10) {
      const functionSig = item.input.slice(0, 10); // 0xbeabacc8 这个方法可能是DTT转账也可能是合约转DTT
      if (functionSig == "0xbeabacc8") {
        let obj = distinguishTransaction(item.input);
        return obj.type;
      } else {
        if (item.to && isContractAddress(item.to)) {
          let val = item.to.toLowerCase();
          let obj = {};
          contractAddressArr.forEach((item) => {
            obj[item.address] = item.unit;
          });
          return obj[val] ? obj[val] : null;
        }
        return null;
      }
    } else {
      return item.value > 0 ? "DTT" : null;
    }
  }
}
// 是否是合约地址
export function isContractAddress(key) {
  if (!key) return;
  let val = key.toLowerCase();
  let arr = [];
  contractAddressArr.forEach((item) => {
    if (item.address != "0x" && item.address != "0x0") {
      arr.push(item.address);
    }
  });
  return arr.includes(val);
}
// 转账类型
export function transactionType(params) {
  if (params == "0x") {
    return transactionObj[i18n.locale].transfer;
  }
  let key = params.substring(0, 10);

  return transactionObj[i18n.locale][key];
}
// 对数据input根据abi解码
export function abiDecoder(input) {
  addABI(ABI);
  const decodedData = decodeMethod(input);
  console.log("decodedData:", decodedData);
  return decodedData ? decodedData : null;
}
export function getDetailsAbiDecoder(input) {
  addABI(ABI);
  let decodedData = decodeMethod(input);
  if (
    decodedData &&
    decodedData.name == "swap" &&
    decodedData.params.length == 4
  ) {
    let unit0 = "",
      unit1 = "";
    decodedData.params.forEach((item) => {
      switch (item.name) {
        case "t0":
          unit0 = getUnit(item.value);
          break;
        case "t1":
          unit1 = getUnit(item.value);
          break;
        case "in0":
          item.value = getAmountAccuracy(item.value, unit0) + " " + unit0;
          break;
        case "out1":
          item.value = getAmountAccuracy(item.value, unit1) + " " + unit1;
          break;
      }
    });
  }

  // 处理 withdrawDtt 或 withdrawDTT（从 ABI 解析出来的）
  if (decodedData && (decodedData.name === "withdrawDtt" || decodedData.name === "withdrawDTT")) {
    // 强制设置 unit 为 DTT
    decodedData.unit = "DTT";
    
    // 修复参数名：_toAddress -> to
    decodedData.params.forEach((param) => {
      if (param.name === "_toAddress") {
        param.name = "to";
      }
    });
    
    console.log("=== 修复 withdrawDtt decodedData ===");
    console.log("修复后的 decodedData:", decodedData);
  }

  if (!decodedData && input.indexOf("0xae1c7a66") > -1) {
 
    //  解析函数签名
    const functionSignature = input.slice(2, 10); // 提取 ae1c7a66
    console.log("函数签名:", functionSignature); // withdrawDTT

    // 解析参数
    // input 格式: 0x + 函数签名(4字节=8字符) + amount(32字节=64字符) + to(32字节=64字符)
    // 所以 amount 从位置 10 开始，64 个字符
    // to 从位置 74 开始，64 个字符，但地址只取最后 40 个字符（20字节）
    const amountHex = "0x" + input.slice(10, 74); // 金额占 32 字节 = 64 个十六进制字符
    const toHex = input.slice(74, 138); // to 参数占 32 字节 = 64 个十六进制字符
    const address = "0x" + toHex.slice(-40); // 地址占 20 字节 = 40 个十六进制字符，右对齐
    
    const amountWei = web3.utils.hexToNumberString(amountHex);
    const amountEther = web3.utils.fromWei(amountWei, "ether");

    console.log("=== withdrawDTT 解析 ===");
    console.log("input length:", input.length);
    console.log("amountHex:", amountHex);
    console.log("toHex:", toHex);
    console.log("目标地址:", address);
    console.log("金额 (wei):", amountWei);
    console.log("金额 (ether):", amountEther);
    console.log("金额格式化测试:", getAmountAccuracy(amountWei, "DTT"));

    decodedData = {
      name: "withdrawDTT",
      unit: "DTT", // 强制使用 DTT 作为 unit
      params: [
        {
          name: "amount",
          type: "uint256",
          value: amountWei, // 保持原始值，在显示时格式化
        },
        {
          name: "to",
          type: "address",
          value: address,
        },
      ],
    };
  }
  console.log("decodedData:", decodedData);
  return decodedData ? decodedData : null;
}
// 获取不同代币金额精度
export function getAmountAccuracy(amount, unit) {
  if (!amount || amount === '0' || amount === 0) return '0';
  
  try {
    // 将 amount 转换为字符串，处理 BigInt 或超大数字
    let amountStr = String(amount);
    
    // 如果 amount 已经是格式化后的字符串（包含科学计数法或逗号），尝试提取原始值
    if (amountStr.includes('e+') || amountStr.includes('e-') || amountStr.includes(',')) {
      // 尝试从科学计数法字符串中提取
      if (amountStr.includes('e+') || amountStr.includes('e-')) {
        const num = parseFloat(amountStr);
        if (!isNaN(num)) {
          // 如果是科学计数法，需要乘以精度得到原始值
          if (amountAccuracy[unit]) {
            const divisor = amountAccuracy[unit];
            amountStr = String(Math.round(num * divisor));
          } else {
            amountStr = String(num);
          }
        }
      } else {
        // 移除逗号
        amountStr = amountStr.replace(/,/g, '');
      }
    }
    
    if (amountAccuracy[unit]) {
      let divisor = amountAccuracy[unit];
      
      // 使用 BigInt 处理超大数字，避免精度丢失
      let amountBigInt = BigInt(amountStr);
      let divisorBigInt = BigInt(divisor);
      
      // 计算整数部分和小数部分
      let quotient = amountBigInt / divisorBigInt;
      let remainder = amountBigInt % divisorBigInt;
      
      // 将 BigInt 转换为字符串，然后转换为数字，避免精度丢失
      let quotientStr = quotient.toString();
      let remainderStr = remainder.toString();
      
      // 计算小数部分
      let decimalPart = 0;
      if (remainderStr !== '0') {
        // 将 remainder 转换为数字并除以精度
        decimalPart = Number(remainderStr) / Number(divisorBigInt);
      }
      
      // 组合整数和小数部分
      // 检查 quotientStr 是否超过 JavaScript 最大安全整数
      let num;
      if (quotientStr.length > 15 || Number(quotientStr) > Number.MAX_SAFE_INTEGER) {
        // 如果 quotient 太大，使用字符串拼接方式计算
        // 对于小数部分，如果很小可以忽略
        if (decimalPart < 1e-10) {
          // 小数部分可以忽略，直接使用 quotientStr
          num = parseFloat(quotientStr);
        } else {
          // 需要组合整数和小数部分
          num = parseFloat(quotientStr) + decimalPart;
        }
      } else {
        num = Number(quotientStr) + decimalPart;
      }
      
      // 格式化数字 - 调整阈值，避免小数字使用科学计数法
      // 只有真正很大的数字（>= 1e15）才使用科学计数法
      if (num >= 1e15) {
        // 超大数字（>= 1e15）使用科学计数法，保留6位有效数字
        return num.toExponential(6);
      } else if (num >= 1e12) {
        // 大数字（>= 1e12）保留6位小数
        return num.toLocaleString('en-US', { 
          maximumFractionDigits: 6,
          minimumFractionDigits: 0,
          useGrouping: true 
        });
      } else {
        // 普通数字（< 1e12），保留最多4位小数，避免浮点误差显示（如 1.5899999999999999）
        let formatted = num.toLocaleString('en-US', { 
          maximumFractionDigits: 4,
          minimumFractionDigits: 0,
          useGrouping: true 
        });
        
        // 如果格式化后的字符串太长（超过30个字符），使用科学计数法
        if (formatted.length > 30) {
          return num.toExponential(6);
        }
        
        return formatted;
      }
    }
    
    // 如果没有对应的精度配置，直接格式化
    let num = Number(amountStr);
    
    if (isNaN(num)) {
      // 如果无法转换为数字，尝试使用 BigInt
      try {
        let bigIntValue = BigInt(amountStr);
        // 对于没有精度的超大数字，使用科学计数法
        return Number(bigIntValue).toExponential(6);
      } catch (e) {
        return amountStr; // 如果都失败了，返回原始字符串
      }
    }
    
    let formatted = num.toLocaleString('en-US', { 
      maximumFractionDigits: 4,
      minimumFractionDigits: 0,
      useGrouping: true 
    });
    
    if (formatted.length > 30) {
      return num.toExponential(6);
    }
    
    return formatted;
  } catch (error) {
    console.error('getAmountAccuracy error:', error, amount, unit);
    // 如果出错，返回原始值或 '0'
    return String(amount) || '0';
  }
}

// 解析InputData数据
export function handleInputData(item) {
  let unit = getUnit(item);
  unit = unit ? unit : "";

  let value = item.value + " " + unit;
  let type = transactionType(item.input);
  let to = item.to;
  let amountEther = 0;
  if (!type && item.input.indexOf("0xae1c7a66") > -1) {
    const amountHex = "0x" + item.input.slice(24, 74); // 金额占 32 字节
    const amountWei = web3.utils.hexToNumberString(amountHex);
    amountEther = web3.utils.fromWei(amountWei, "ether");
    amountEther = Number(amountEther).toFixed(3);
  }
  if (item.input.indexOf("0x00f714ce") > -1) {
    const amountHex = "0x" + item.input.slice(24, 74); // 金额占 32 字节
    const amountWei = web3.utils.hexToNumberString(amountHex);
    amountEther = getAmountAccuracy(amountWei, unit);
  }
  if (["dtt", "DTT"].includes(unit)) {
    let amount = getAmountAccuracy(item.value, "DTT") + " " + "DTT"
    if(item.input.indexOf('0xae1c7a66')>-1||item.input.indexOf('0x00f714ce')>-1){
      amount = amountEther+ " " + "DTT"
    }
    return {
      value:amount,
      unit: unit,
      transactionType: type,
      to: to,
    };
  } else {
    if (item.input.length > 10) {
      let decodedData = abiDecoder(item.input);
      if (decodedData) {
        type = decodedData.name;
        decodedData.params.forEach((val) => {
          if (val.name == "token") {
            let tokenUnit = getUnit(val.value);
            unit = tokenUnit ? tokenUnit : "";
          }
          if (val.name == "to") {
            to = val.value;
          }
          if (val.name == "amount" || val.name == "value") {
            value = getAmountAccuracy(val.value, unit) + " " + unit;
          }
        });
      }
    }
    if (!unit) {
      unit = this.$getUnit(item.to) || "";
      let otherValue = this.$getAmountAccuracy(value, unit) + " " + unit;
      value = otherValue;
    }

    return {
      unit: unit,
      value: value,
      transactionType: type,
      to: to,
    };
  }
}

export function isDtt(item) {
  if (["0x", "0x0"].includes(item.input)) {
    return "DTT";
  }
  if (item.value > 0 && ["0x", "0x0"].includes(item.input)) {
    return "DTT";
  }
  if (item.input && item.input.length > 10) {
    const functionSig = item.input.slice(0, 10); // 0xbeabacc8 这个方法可能是DTT转账也可能是合约转DTT
    if (functionSig == "0xbeabacc8") {
      let obj = distinguishTransaction(item.input);
      return obj.type == "DTT" ? true : false;
    } else {
      return false;
    }
  } else {
    return item.value > 0 ? true : false;
  }
}

export function convertToDecimal(value) {
  if (value) {
    return value.toFixed(20).replace(/0+$/, "").replace(/\.$/, "");
  }
  return 0;
}

export const FilterAddress = function (val, number) {
  let num = number ? number : 5;
  if (val && val.length > 10) {
    let start = val.substr(0, num);
    let end = val.substr(-num, num);
    return start + "..." + end;
  } else {
    return val;
  }
};

export function formatNumber(num) {
  // 判断是否有小数部分
  if (num % 1 !== 0) {
    // 有小数部分，保留最多8位小数
    return parseFloat(num.toFixed(8));
  }
  // 如果没有小数部分，直接返回整数
  return num;
}

// 判断是DTT转账还是合约转DTT,0xbeabacc8 这个方法可能是DTT转账也可能是合约转DTT
function distinguishTransaction(inputData) {
  const functionSig = inputData.slice(0, 10); // 0xbeabacc8 这个方法可能是DTT转账也可能是合约转DTT
  if (inputData.length == 138) {
    // 长度为138位
    // 去掉 0x 前缀
    const data = inputData.startsWith("0x") ? inputData.slice(2) : inputData;
    console.log("data----------", data);
    // 提取参数（每个 32 字节）
    const tokenContract = `0x${data.slice(32, 72)}`; // 地址从第 12 字节开始（跳过前导零）
    console.log("tokenContract----------", tokenContract);
    const amountHex = `0x${data.slice(74, 138)}`; // uint256
    const amount = Number(BigInt(amountHex)); // 金额
    console.log("contractAddressArr--------", contractAddressArr);
    let curArr = contractAddressArr.filter(
      (item) => item.address == tokenContract.toLowerCase()
    );
    if (curArr && curArr.length > 0) {
      const unit = curArr[0].unit;
      return {
        type: unit,
        from: tokenContract,
        to: tokenContract,
        amount: amount,
        unit: unit,
      };
    }
  } else {
    // 提取参数
    const param1 = inputData.slice(10, 74); // 第一个参数 (64 字符)用来区分是不是dtt，如果是dtt就全都是0
    const param2 = inputData.slice(74, 138); // 第二个参数
    const param3 = inputData.slice(138); // 第三个参数 (金额)

    // 检查是否为主币 (DTT)
    if (param1 === "0".repeat(64)) {
      console.log("这是主币 DTT 交易");
      const receiver = "0x" + param2.slice(24); // 接收地址
      const amount = Number(BigInt("0x" + param3)); // 金额
      return { type: "DTT", to: receiver, amount: amount };
    }

    // 检查是否为代币
    const tokenContract = "0x" + param1.slice(24);
    console.log("contractAddressArr--------", contractAddressArr);
    let curArr = contractAddressArr.filter(
      (item) => item.address == tokenContract.toLowerCase()
    );
    if (curArr && curArr.length > 0) {
      console.log("这是代币交易");
      const to = "0x" + param2.slice(24); // 接收地址
      const amount = Number(BigInt("0x" + param3)); // 金额
      const unit = curArr[0].unit;
      return {
        type: unit,
        from: tokenContract,
        to: to,
        amount: amount,
        unit: unit,
      };
    }
  }
  return { type: "Unknown" };
}

export function isMobileByUA() {
  const ua = navigator.userAgent;
  const mobileKeywords =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Harmony/i;
  return mobileKeywords.test(ua);
}
